import type { ReactElement } from 'react'
import { useState } from 'react'
import { Button, Modal, Header, Spacer, TextField } from '@truepill/react-capsule'
import styled from 'styled-components'

interface ModalProps {
  isOpen: boolean
  onDismiss: () => void
  onClick: (message: string) => void
}

const StatusCheckPriorAuthorizationModal = ({ isOpen, onClick, onDismiss }: ModalProps): ReactElement => {
  const [message, setMessage] = useState('')

  const onSetStatus = () => {
    onClick(message)
  }

  return (
    <Modal isOpen={isOpen} onDismiss={onDismiss} aria-labelledby="title" overlayCss={{ 'z-index': 10 }}>
      <>
        <StyledHeader variant="xl" id="title">
          Status Check
        </StyledHeader>
        <Spacer size="xl" />
        <TextField
          type="textarea"
          label="Message"
          placeholder="Save message to Status Check Log and Notes"
          rows={3}
          onChange={e => setMessage(e.target.value)}
        />
        <Spacer size="xl" />
        <StyledContainer>
          <Button variant="primary-text" size="md" onClick={onDismiss}>
            Cancel
          </Button>
          <Button size="md" onClick={onSetStatus}>
            Set status
          </Button>
        </StyledContainer>
      </>
    </Modal>
  )
}

const StyledHeader = styled(Header)`
  font-weight: bold;
  font-size: 36px;
`

const StyledContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  gap: 15px;
`

export default StatusCheckPriorAuthorizationModal
